/**
 * Which post outcome a session ends up with.
 *
 * ONE RULE, TWO CALLERS. The API writes the outcome onto `app.time_session` and the
 * browser renders a badge from it; both have to agree about what happens when a
 * session appears in more than one result, and they were previously two copies of the
 * same three-line decision sitting in different packages.
 *
 * 🔥 MOST SEVERE WINS. A split day fans into one entry per department share, every
 * share built from the SAME session ids, so one share can post while another fails.
 * "Posted" must never be the one that survives that: the row would read as finished
 * while some of its hours are not in NetSuite.
 */
/** Worse is higher. Ties keep the FIRST seen, so the order of equals does not matter. */
const SEVERITY = { posted: 0, skipped: 1, failed: 2 };
/** True when `candidate` should replace `current`. */
export function isWorsePostOutcome(candidate, current) {
    return current === undefined || SEVERITY[candidate] >= SEVERITY[current];
}
/**
 * Reduce a post response to one outcome per session.
 *
 * Takes the minimum shape both callers have rather than the full result type, so
 * neither package has to import the other's.
 */
export function worstOutcomeBySession(results) {
    const worst = new Map();
    for (const result of results) {
        for (const sessionId of result.sessionIds) {
            if (isWorsePostOutcome(result.status, worst.get(sessionId)?.status)) {
                worst.set(sessionId, { status: result.status, message: result.message ?? null });
            }
        }
    }
    return worst;
}
//# sourceMappingURL=post-outcome.js.map